exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w60[data-v-96b07194] {\n  width: 60%;\n}\n[data-v-96b07194] .v-list__tile:not(.v-list__tile--avatar) {\n  height: 32px;\n}\n[data-v-96b07194] .v-list__tile:hover {\n  background: #eee;\n}\n.v-dialog__content[data-v-96b07194] {\n  z-index: 1030 !important;\n}\n", ""]);

// exports
